export { default as BlueCheckmark } from './BlueCheckmark'
export { default as GrayCheckmark } from './GrayCheckmark'
export { default as NavyCheckmark } from './NavyCheckmark'
export { default as WhiteCheckmark } from './WhiteCheckmark'



// WEBPACK FOOTER //
// ./src/core/icons/Checkmark/index.js